// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2ea4acf1","453":"f8768dfd","455":"cdab925f","762":"eae6b758","854":"81a81f28"}[chunkId] + ".chunk.js";
};